"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startApplePaySession = exports.sendOrder = exports.calculatePromoRewards = exports.requestPromoForCode = exports.requestDefaultBrandPromo = exports.requestShippingMethods = exports.getFaceplateForCode = exports.getFaceplates = exports.getBrandConfig = exports.createNewSession = exports.CAPI_URIS = exports.CAPI_URI_VERSION = exports.BRAND_CONFIG_FIELDS = void 0;
// Constants
var BRAND_CONFIG_FIELDS = {
  PREFERENCES: 'preferences',
  // Suggestions the Brand makes on the purchase experience
  CATALOG: 'catalog',
  // The set of purchasable items from the Brand's Merchant
  PAYMENT: 'payment',
  // The Brand's payment configuration
  SHIPPING: 'shipping',
  // The Brand's shipping configuration
  FEATURES: 'features',
  // The set of optional features and whether the Brand supports them or not
  PROGRAMS: 'programs',
  // The set of active programs associated with the brand, and their associated configurations (e.g. catalogs)
  META: 'meta',
  // Brand metadata, e.g. brand name
  BALANCE: 'balance',
  // The Brand's methods of balance lookup
  ACCESSORIES: 'accessories',
  // Any accessories available for the brand
  LIMITS: 'limits' // The Brands's limits on line items in the cart

};
exports.BRAND_CONFIG_FIELDS = BRAND_CONFIG_FIELDS;
var CAPI_URI_VERSION = 'v4';
exports.CAPI_URI_VERSION = CAPI_URI_VERSION;
var CAPI_URIS = {
  order: "".concat(CAPI_URI_VERSION, "/order/"),
  defaultPromo: "".concat(CAPI_URI_VERSION, "/promo/"),
  promo: function promo(promoCode) {
    return "".concat(CAPI_URI_VERSION, "/promo/").concat(promoCode, "/");
  },
  applyPromo: function applyPromo(promoCode) {
    return "".concat(CAPI_URI_VERSION, "/promo/").concat(promoCode, "/apply/");
  },
  session: "".concat(CAPI_URI_VERSION, "/session"),
  brandConfig: "".concat(CAPI_URI_VERSION, "/config"),
  faceplates: "".concat(CAPI_URI_VERSION, "/faceplates"),
  shippingMethods: "".concat(CAPI_URI_VERSION, "/shipping/"),
  startApplePaySession: "".concat(CAPI_URI_VERSION, "/apple-pay-session/start/")
};
/**
 * Create a new session ID for use in subsequent requests to CAPI
 *
 * @param {AxiosInstance} axiosClient - An axios instance created by `createCapiClient`
 * @param {Object} data - Set of parameters needed to create a new CAPI session.
 *      See the `createCapiSession` redux action for details.
 *      TODO: Should this be more explicit for callers not using redux?
 * @returns {AxiosPromise} A Promise containing the response/errors of the CAPI call
 */

exports.CAPI_URIS = CAPI_URIS;

var createNewSession = function createNewSession(axiosClient, data) {
  return axiosClient.post(CAPI_URIS.session, data);
};
/**
 * Retrieve Brand configuration information from CAPI
 *
 * @param {AxiosInstance} axiosClient - An axios instance created by `createCapiClient`
 * @param {array} fields - A list of fields defined in BRAND_CONFIG_FIELDS
 * @returns {AxiosPromise} A Promise containing the response/errors of the CAPI call
 */


exports.createNewSession = createNewSession;

var getBrandConfig = function getBrandConfig(axiosClient, fields) {
  var params = fields ? "?fields=".concat(fields.join(',')) : '';
  var configUrl = "".concat(CAPI_URIS.brandConfig).concat(params);
  return axiosClient.get(configUrl);
};
/**
 * Get the configured facplates
 *
 * The ordering token is used to determine what faceplates should be returned for the
 * calling brand and application. The faceplates are returned in a list of groups
 * containing either one or many groups. Each group defines it's delivery method. Brands
 * that have design center enabled may get many categorized groups where as brands that
 * do not have it enabled will get a group for each delivery method the implement ('ELECTRONIC'
 *  or 'PLASTIC'). See README.md for details and examples.
 *
 * @param {AxiosInstance} axiosClient - The configured client
 * @returns {AxiosPromise|*}
 */


exports.getBrandConfig = getBrandConfig;

var getFaceplates = function getFaceplates(axiosClient) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return axiosClient.get(CAPI_URIS.faceplates, {
    params: params
  });
};
/**
 * Get the faceplate data for a given faceplate code.
 * @param {AxiosInstance} axiosClient - The configured client
 * @param {string} code - The faceplate code
 * @returns {AxiosPromise|*}
 */


exports.getFaceplates = getFaceplates;

var getFaceplateForCode = function getFaceplateForCode(axiosClient, code) {
  return axiosClient.get("".concat(CAPI_URIS.faceplates, "/").concat(code));
};
/**
 *
 * =================================
 *         POST DATA FIELDS
 * =================================
 * brandCode:          required
 * productCode:        default='NORM'
 * currencyCode:       default='USD'
 * countryCode:        default='US'
 * postalCode:         required
 * carrier:             optional
 * state:               optional
 * city:                optional
 * street1:             optional
 * street2:             optional
 * quantity:            default=1
 * includeInactive:    optional
 *=================================
 *
 * @param {AxiosInstance} axiosClient - The configured client
 * @param {object} data - As described in post data fields
 * @returns {AxiosPromise|*}
 */


exports.getFaceplateForCode = getFaceplateForCode;

var requestShippingMethods = function requestShippingMethods(axiosClient, data) {
  return axiosClient.post(CAPI_URIS.shippingMethods, data);
};
/**
 * Get the default brand promo for configured CAPI client
 * @param {AxiosInstance} axiosClient - The configured client
 * @param {string} language - The specified language
 * @param {string} currency - The specified currency
 * @returns {AxiosPromise|*}
 */


exports.requestShippingMethods = requestShippingMethods;

var requestDefaultBrandPromo = function requestDefaultBrandPromo(axiosClient, language, currency) {
  var params = {
    language: language,
    currency: currency
  };
  return axiosClient.get(CAPI_URIS.defaultPromo, {
    params: params
  });
};
/**
 * Get the promo data for a given promo code.
 * @param {AxiosInstance} axiosClient - The configured client
 * @param {string} promoCode - The promo code
 * @param {string} language - The specified language
 * @param {string} currency - The specified currency
 * @returns {AxiosPromise|*}
 */


exports.requestDefaultBrandPromo = requestDefaultBrandPromo;

var requestPromoForCode = function requestPromoForCode(axiosClient, promoCode, language, currency) {
  var params = {
    language: language,
    currency: currency
  };
  return axiosClient.get(CAPI_URIS.promo(promoCode), {
    params: params
  });
};
/**
 * Calculate promo rewards for a potential order.
 * @param {AxiosInstance} axiosClient - The configured client
 * @param {string} promoCode - The promo code
 * @param {object} orderData - The order we will be calculated rewards for
 * @param {string} language - The specified language
 * @param {string} currency - The specified currency
 * @returns {AxiosPromise|*}
 */


exports.requestPromoForCode = requestPromoForCode;

var calculatePromoRewards = function calculatePromoRewards(axiosClient, promoCode, orderData) {
  return axiosClient.post(CAPI_URIS.applyPromo(promoCode), orderData);
};
/**
 * Prepare and place an order
 *
 * @param {AxiosInstance} axiosClient - An axios instance created by `createCapiClient`
 * @param {Object} orderData - Payment data sufficient to create the order and Items being ordered
 * @returns {AxiosPromise} A Promise resolving with the response/errors of the CAPI call
 */


exports.calculatePromoRewards = calculatePromoRewards;

var sendOrder = function sendOrder(axiosClient, orderData) {
  return axiosClient.post(CAPI_URIS.order, orderData);
};
/**
 * Start an Apple Pay session
 *
 * @param {AxiosInstance} axiosClient - The configured client
 * @param {string} validationUrl - Apple provided URL to use when starting the session
 * @returns {AxiosPromise|*}
 */


exports.sendOrder = sendOrder;

var startApplePaySession = function startApplePaySession(axiosClient, validationUrl) {
  return axiosClient.post(CAPI_URIS.startApplePaySession, validationUrl);
};

exports.startApplePaySession = startApplePaySession;